import { Button } from "@repo/ui4/components/Button";
import { AlertCircle } from "lucide-react";

const homeHost = process.env.NEXT_PUBLIC_HOME_HOST;

type ErrorScreenProps = {
  message: string;
  showHomeLink?: boolean;
  onSelectWorkspace?: () => void;
  // NOTE: セッションは残っているが復帰できない状態から抜け出すための導線。
  //       ID セッションを破棄する（他アプリを含めてサインアウトされる）ため、
  //       渡されたときのみ表示する
  onReauthenticate?: () => void;
};

export const ErrorScreen = ({
  message,
  showHomeLink,
  onSelectWorkspace,
  onReauthenticate,
}: ErrorScreenProps) => {
  const hasHomeLink = showHomeLink === true && homeHost != null;
  const hasActions =
    onSelectWorkspace != null || onReauthenticate != null || hasHomeLink;

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-12">
      <div className="flex flex-col items-center gap-4">
        <div className="text-muted-foreground">
          <AlertCircle size={48} />
        </div>
        <p className="text-lg text-muted-foreground">{message}</p>
      </div>
      {hasActions && (
        <div className="flex flex-col items-center gap-4">
          {onSelectWorkspace != null && (
            <Button variant="outline" onClick={() => onSelectWorkspace()}>
              別のワークスペースを選ぶ
            </Button>
          )}
          {onReauthenticate != null && (
            <Button variant="outline" onClick={() => onReauthenticate()}>
              ログアウトして再ログイン
            </Button>
          )}
          {hasHomeLink && (
            <a
              href={homeHost}
              className="text-accent-subtle-foreground hover:underline"
            >
              Speria ホームに戻る
            </a>
          )}
        </div>
      )}
    </div>
  );
};
